export default "__VITE_ASSET__DCAV0EGn__"